import './GroupedChip.css';
export var first = '_4mpedx2-3-8-0';
export var grouped = '_4mpedx1-3-8-0';
export var hidden = '_4mpedx0-3-8-0';